
<div class="cp-close">
  <!-- <div class="stick"></div> -->
  <div class="site" @click="handleClose($event)" />
</div>
